import { render, staticRenderFns } from "./YesIconGrey.vue?vue&type=template&id=ba235226&scoped=true"
import script from "./YesIconGrey.vue?vue&type=script&lang=ts"
export * from "./YesIconGrey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba235226",
  null
  
)

export default component.exports